// Axis-geometry helper shared by the floor-plan transform gizmo: the closest
// parameter along an axis line to a pointer ray (used to slide a placement
// along a world axis under the cursor).

import * as THREE from "three";

const _w0 = new THREE.Vector3();

// Parameter `t` along the axis line (C + t·A) closest to the ray (Ro + s·Rd),
// with A a unit vector. Returns null when the ray is ~parallel to the axis.
export function closestParamOnAxis(
  C: THREE.Vector3,
  A: THREE.Vector3,
  Ro: THREE.Vector3,
  Rd: THREE.Vector3,
): number | null {
  _w0.copy(C).sub(Ro);
  const b = A.dot(Rd);
  const c = Rd.dot(Rd);
  const d = A.dot(_w0);
  const e = Rd.dot(_w0);
  const denom = b * b - c;
  if (Math.abs(denom) < 1e-6) return null;
  const s = (d * b - e) / denom;
  return s * b - d;
}
